import axios from 'axios';
import env from '../env';

const AUTH_KEYS = [
  'provider', 'microsoftJWT', 'profileImage', 'username', 'email',
  'phone', 'blocked', 'customerCode', 'customerID',
  'isAdmin', 'isModerator', 'isUser', 'localProvider',
];

export function clearPortalAuthStorage() {
  AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
  try { sessionStorage.removeItem('redirect'); } catch { /* */ }
}

export function storeLogin(params, cbClear) {
  if (!params || typeof params !== 'object') return;
  Object.entries(params).forEach(([key, value]) => {
    if (typeof value !== 'object' || value === null) {
      localStorage.setItem(key, value == null ? '' : String(value));
    }
  });
  if (typeof cbClear === 'function') cbClear();
}

export async function getProfileImage() {
  const jwt = localStorage.getItem('microsoftJWT');
  if (!jwt || jwt.startsWith('L')) return;
  try {
    const { data } = await axios.get(`${env.REACT_APP_SSO_BACKEND}/auth/me`, {
      headers: { jwt },
    });
    if (data?.profileImage) {
      localStorage.setItem('profileImage', data.profileImage);
    }
  } catch { /* ignore */ }
}

export function recallLoginSSO(httpStatus) {
  if (httpStatus === undefined || (httpStatus !== 401 && httpStatus !== 403)) return;
  const provider = localStorage.getItem('provider');
  if (provider !== 'sso' || localStorage.getItem('disableSSO') === 'true') return;
  const key = '_ssoRecallTs';
  const last = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - last < 10000) return;
  sessionStorage.setItem(key, String(Date.now()));
  sessionStorage.setItem('redirect', window.location.pathname);
  window.location.href = `${env.REACT_APP_SSO_BACKEND}/auth/sso/login`;
}

